import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyConsumableRefundBillItem from './pharmacy-consumable-refund-bill-item';
import PharmacyConsumableRefundBillItemDetail from './pharmacy-consumable-refund-bill-item-detail';
import PharmacyConsumableRefundBillItemUpdate from './pharmacy-consumable-refund-bill-item-update';
import PharmacyConsumableRefundBillItemDeleteDialog from './pharmacy-consumable-refund-bill-item-delete-dialog';

const PharmacyConsumableRefundBillItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyConsumableRefundBillItem />} />
    <Route path="new" element={<PharmacyConsumableRefundBillItemUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyConsumableRefundBillItemDetail />} />
      <Route path="edit" element={<PharmacyConsumableRefundBillItemUpdate />} />
      <Route path="delete" element={<PharmacyConsumableRefundBillItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyConsumableRefundBillItemRoutes;
